function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.781,87.353C17.562,87.638 17.524,88.024 17.683,88.347C17.842,88.67 18.171,88.874 18.531,88.874L30.201,88.874C30.5,88.874 30.781,88.733 30.959,88.494L49.392,63.768C49.394,63.764 49.397,63.761 49.4,63.757C49.989,62.944 50.906,61.567 52.149,59.625C52.977,60.882 53.786,62.064 54.576,63.171L73.065,88.487C73.243,88.73 73.526,88.874 73.828,88.874L85.849,88.874C86.207,88.874 86.533,88.673 86.694,88.354C86.855,88.035 86.822,87.653 86.609,87.366L59.236,50.439C59.236,50.439 84.594,17.569 84.594,17.569C84.815,17.284 84.853,16.898 84.694,16.575C84.535,16.251 84.206,16.046 83.846,16.046L73.277,16.046C72.987,16.046 72.713,16.18 72.533,16.408L57.759,35.228C55.867,37.603 54.188,39.897 52.721,42.111C51.517,40.184 49.792,37.689 47.543,34.626C47.543,34.627 34.22,16.433 34.22,16.433C34.042,16.19 33.759,16.046 33.457,16.046L21.887,16.046C21.53,16.046 21.204,16.247 21.043,16.565C20.882,16.884 20.914,17.266 21.126,17.553L45.747,50.949C45.747,50.949 17.781,87.353 17.781,87.353Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.e99291daeb261f239359ff96452c7b9a.svg";
export { ForwardRef as ReactComponent };